import {
  GetUserUsageReportCustomersSuccessType,
  GetUserUsageReportsSuccessType,
  GET_USER_USAGE_REPORTS_SUCCESS,
  GET_USER_USAGE_REPORT_ACCESS_FLAG_SUCCESS,
  GET_USER_USAGE_REPORT_CUSTOMERS_SUCCESS,
  USER_USAGE_REPORT_CLEAR,
  USER_USAGE_REPORT_LOADING,
} from './UserUsageReport.types';
import { Dispatch } from 'redux';
import {
  fetchCustomersService,
  fetchExcelExportFile,
  fetchHasBillingInfoPermissions,
  fetchUserUsageReportsService,
} from '.';
import {
  httpError,
  json,
  showSuccessNotification,
  showWarnNotification,
} from 'common';
import {
  CustomerUsageReport,
  UserCustomer,
  UserUsageReportFormData,
  UserUsageReportResult,
} from './models';
import { blob, saveFile } from 'common/helpers';
import { loginPagesLoading } from 'pages/Login';
import { IPublicClientApplication } from '@azure/msal-browser';

export const userUsageReportClear = () => {
  return {
    type: USER_USAGE_REPORT_CLEAR,
  };
};

export const getUserUsageReportAccessFlag =
  (bearerToken: string, instance?: IPublicClientApplication) =>
  (dispatch: Dispatch) => {
    dispatch(setUserUsageReportLoading(true));
    dispatch(loginPagesLoading(true));
    fetchHasBillingInfoPermissions(bearerToken)
      .then(httpError(dispatch, instance))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        dispatch(getUserUsageReportAccessFlagSuccess(response));
        dispatch(setUserUsageReportLoading(false));
        dispatch(loginPagesLoading(false));
      })
      .catch((error) => {
        dispatch(setUserUsageReportLoading(false));
        showWarnNotification(`Usage Report Access Flag`, error.message);
      });
  };

export const getUserUsageReportAccessFlagSuccess = (accessFlag: boolean) => {
  return {
    type: GET_USER_USAGE_REPORT_ACCESS_FLAG_SUCCESS,
    accessFlag,
  };
};

export const getCustomers = (bearerToken: string) => (dispatch: Dispatch) => {
  dispatch(setUserUsageReportLoading(true));
  fetchCustomersService(bearerToken)
    .then(httpError(dispatch))
    .then(json)
    .then((response) => {
      if (response.errorMessage) {
        throw Error(response.errorMessage);
      }
      dispatch(getCustomersSuccess(response));
      dispatch(setUserUsageReportLoading(false));
    })
    .catch((error) => {
      dispatch(setUserUsageReportLoading(false));
      showWarnNotification(`Customers`, error.message);
    });
};

const getCustomersSuccess = (
  customers: UserCustomer[],
): GetUserUsageReportCustomersSuccessType => {
  return {
    type: GET_USER_USAGE_REPORT_CUSTOMERS_SUCCESS,
    customers,
  };
};

export const getUserUsageReportsByCustomer = (
  params: UserUsageReportFormData,
  bearerToken: string,
) => {
  const searchRequest: any = {
    customerCode: params?.customer ?? '',
    from: params?.from,
    to: params?.to,
  };

  return (dispatch: Dispatch) => {
    dispatch(setUserUsageReportLoading(true));
    fetchUserUsageReportsService(searchRequest, bearerToken)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        return response;
      })
      .then((result: UserUsageReportResult) => {
        dispatch(getUserUsageReportsSuccess(result));
      })
      .catch((error) => {
        dispatch(setUserUsageReportLoading(false));
        showWarnNotification(`User Usage Reports`, error.message);
      });
  };
};

export const setUserUsageReportLoading = (loading: boolean) => {
  return {
    type: USER_USAGE_REPORT_LOADING,
    payload: loading,
  };
};

const getUserUsageReportsSuccess = (
  result: UserUsageReportResult,
): GetUserUsageReportsSuccessType => {
  return {
    type: GET_USER_USAGE_REPORTS_SUCCESS,
    result,
  };
};

export const exportReportsToExcel = (
  reports: CustomerUsageReport[],
  searchCriteria: string,
  bearerToken: string,
) => {
  return (dispatch: Dispatch) => {
    const searchRequest: UserUsageReportResult = {
      reports: reports,
      searchCriteria: searchCriteria,
    };

    dispatch(setUserUsageReportLoading(true));
    fetchExcelExportFile(searchRequest, bearerToken)
      .then(httpError(dispatch))
      .then(blob)
      .then((blob) => {
        dispatch(setUserUsageReportLoading(false));
        saveFile(blob, `Report.xlsx`);
        showSuccessNotification(`Fetch file`, `File was exported`);
      })
      .catch((error) => {
        dispatch(setUserUsageReportLoading(false));
        showWarnNotification(`Fetch file`, error.message);
      });
  };
};
